import Storage from 'react-native-storage';
import { STORAGE_TYPES } from './types/storage.types';

let storage = null;

//region init

const getStorageAPI = () => {
    if (!process.env.IS_WEB) {
        var React = require('react-native');
        return React.AsyncStorage;
    }

    return window.localStorage;
};

const saveStorageAPI = storage => {
    if (process.env.IS_WEB) {
        window.storage = storage;
    } else {
        global.storage = storage;
    }
};

export const init = () => {
    if (storage) {
        return storage;
    }

    storage = new Storage({
        size: 10000000,
        defaultExpires: 1000 * 3600 * 24,
        // expires: null,
        autoSync: false,
        syncInBackground: false,
        storageBackend: getStorageAPI()
    });
    saveStorageAPI(storage);

    return storage;
};

//endregion

//region API

export const save = (key, data) => {
    let params = {
        key,
        data,
        expires: null //1000 * 3600 * 24 // 1 day
    };
    return storage.save(params);
};

export const load = (key, cbSuccess, cbFail = null) => {
    if (cbSuccess && cbFail) {
        return storage.load({ key }).then(cbSuccess).catch(fail(cbFail));
    }

    if (cbFail) {
        return storage.load({ key }).catch(fail(cbFail));
    }

    if (cbSuccess) {
        return storage.load({ key }).then(cbSuccess).catch(fail());
    }

    return storage.load({ key }).catch(fail());
};

export const remove = key => {
    return storage.remove({ key });
};

export const fail = cb => {
    return error => {
        if (!error) {
            return;
        }

        switch (error.name) {
            case STORAGE_TYPES.ERROR_NOT_FOUND:
            case STORAGE_TYPES.ERROR_EXPIRED:
                if (cb) {
                    cb(error);
                } else {
                    throw error;
                }
                break;
            default:
                throw error;
        }
    };
};

//endregion


// WEBPACK FOOTER //
// ./~/pluton-core/lib/device/storage.js